import { render } from "./UofM6Dimensions.vue?vue&type=template&id=46c0ff35&scoped=true"
import script from "./UofM6Dimensions.vue?vue&type=script&lang=js"
export * from "./UofM6Dimensions.vue?vue&type=script&lang=js"

import "./UofM6Dimensions.vue?vue&type=style&index=0&id=46c0ff35&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c0ff35"]])

export default __exports__